import { useState, useEffect } from 'react';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import { useTranslation } from 'react-i18next';
import { useInvokeSWRService } from '@dxb-web-ui-framework/common/hooks';
import { DownloadTypes } from '../components/Generic/FileDownload/FileDownload';
import { downloadFile } from '../utils';
import { transactionService } from '../../../../channels/secure-web/services';

const useDownloadTransactionDetails = () => {
  const [infoForDownload, setInfoForDownload] =
    useState<Nullable<{ orderId: string; accountNumber: string; meta: { timestamp: string } }>>(null);
  const { t } = useTranslation();

  const shouldDownloadTransactionDetails = Boolean(infoForDownload);

  const onDownloadDetails = (orderId: string, accountNumber: string) => {
    setInfoForDownload({ orderId, accountNumber, meta: { timestamp: new Date().toISOString() } });
  };

  const { data: downloadData, isLoading: isLoadingDownloadData } = useInvokeSWRService<{ report: string }>(
    transactionService.GetConsolidatedTransactionDetailsPrint,
    {
      orderId: infoForDownload?.orderId,
      accountNumber: infoForDownload?.accountNumber,
      meta: infoForDownload?.meta,
    },
    shouldDownloadTransactionDetails,
  );

  useEffect(() => {
    if (downloadData && infoForDownload) {
      downloadFile(
        `${t('useDownloadTransactionDetails.title')} ${infoForDownload.orderId}`,
        downloadData.report,
        DownloadTypes.PDF,
      );
    }
  }, [downloadData, t, infoForDownload]);

  return { isLoadingDownloadData, onDownloadDetails };
};

export { useDownloadTransactionDetails };
